import api from "../../helpers/api";



export const getActivites = (options) =>
  api.post("activities/search" , {...options});

  export const getActivity = activityId => api.get(`activities/${activityId}`);